const DISPLAY_VARIANTS = {
  DISPLAY_LG: "display-lg",
  DISPLAY_MD: "display-md",
  DISPLAY_SM: "display-sm"
};
export {
  DISPLAY_VARIANTS
};
//# sourceMappingURL=constants.mjs.map
